import { useState, useEffect } from "react";
import "./Home.css";
import api from "../../Api/axios";
import DreamGarden from "../DreamGarden/DreamGarden"
import Services from "../Services/Services"
import Product from "../OurProducts/OurProducts"
import Garden2 from "../../Images/Garden2.webp";
import Garden3 from "../../Images/Garden3.webp";
import Garden4 from "../../Images/Garden4.jpeg";
import Garden5 from "../../Images/Garden5.jpg";
import Garden6 from "../../Images/Garden6.webp";
import Garden7 from "../../Images/Garden7.webp";
import Garden20 from "../../Images/Garden7.webp";
import Garden21 from "../../Images/Garvan21.jpg";
import Garden22 from "../../Images/garvana22.jpg";
import Garden23 from "../../Images/garvana23.jpg";
import Garden24 from "../../Images/garvana24.jpeg";
import GardenMap1 from "../../Images/GarvanaMap1.jpg";
import GardenMap2 from "../../Images/garvanaMap2.jpg";

import GarvanaHome2 from "../../Images/GarvanaHome2.jpg";
import GarvanaHome3 from "../../Images/GarvanaHome3.jpg";
import GarvanaHome4 from "../../Images/GarvanaHome4.jpg";
// import GarvanaHome5 from "../../Images/GarvanaHome5.webp";
import GarvanaHome6 from "../../Images/GarvanaHome6.jpg";
import GarvanaHome7 from "../../Images/GarvanaHome7.jpg";

export default function Home({ scrollToSection, aboutRef, servicesRef, contactRef }) {
  const slides = [
    { image: GarvanaHome4, text: " Best Landscape design and Garden Management Service", section: servicesRef, color: "#ffd700" },
    { image: Garden24, text:  "Professional Landscaping Architect", section: servicesRef, color: "#04FF3E" },
    { image: GarvanaHome3, text: "Transform Your Outdoor Space with Experts", section: servicesRef, color: "#ff8c00" },
    { image: GarvanaHome2, text: "Creative Outdoor & Landscape Solutions", section: aboutRef, color: "#ffd700" },
    { image: GarvanaHome6, text: "Beautiful & Sustainable Green Spaces", section: aboutRef, color: "#ff8c00" },
    { image: GarvanaHome7, text: "Eco-Friendly & Elegant Garden Designs", section: contactRef, color: "#ffd700" },
    { image: Garden5, text: "Expert Garden & Landscaping Design", section: aboutRef, color: "#ffd700" },
    { image: Garden6, text: "Custom Garden Designs for Every Home", section: contactRef, color: "#ff1493" },
    // { image:  Garden4, text: "Services in Delhi NCR, Noida, Gurugram, Ghaziabad", section: aboutRef, color: "#ffd700" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // -----------------------------
  // 🟢 PRODUCTS + FILTERS
  // -----------------------------
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  // Modal for product details
  const [selectedProduct, setSelectedProduct] = useState(null);

  // useEffect(() => {
  //   loadProducts();
  // }, []);

  const loadProducts = async () => {
    const res = await api.get("/products/all");
    setProducts(res.data);
    setFiltered(res.data);
  };

  // Filter logic
  useEffect(() => {
    let result = products;

    if (search.trim() !== "") {
      result = result.filter((p) =>
        p.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category !== "") {
      result = result.filter((p) => p.category === category);
    }

    if (maxPrice !== "") {
      result = result.filter((p) => p.price <= Number(maxPrice));
    }

    setFiltered(result);
  }, [search, category, maxPrice, products]);

  const categories = [...new Set(products.map((p) => p.category))];

  return (
    <>
      {/* ----------------- SLIDER SECTION ----------------- */}
      <section className="slider-container">
        <div className="slider" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {slides.map((slide, index) => (
            <div key={index} className="slide">
              <img src={slide.image} alt={`slide-${index}`} className="slide-image" />
              <div className="slide-content">
                <h2 style={{ color: slide.color }}>{slide.text}</h2>
                {/* <button onClick={() => scrollToSection(slide.section)}>Learn More</button> */}
              </div>
            </div>
          ))}
        </div>

        {/* Indicators */}
        <div className="indicators">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`circle ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></div>
          ))}
        </div>
      </section>

      <DreamGarden/>
      <Services/>
      <Product/>
      
      {/* <section className="product-section">

        <h2 className="section-title">🌿 Explore Our Products</h2>
        <div className="filters">
          <input
            type="text"
            placeholder="Search plants..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">All Categories</option>
            {categories.map((c, i) => (
              <option key={i} value={c}>{c}</option>
            ))}
          </select>

          <input
            type="number"
            placeholder="Max price"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
          />
        </div>
        <div className="product-grid-home">
          {filtered.length === 0 ? (
            <p className="no-products">No products found</p>
          ) : (
            filtered.map((p) => {
              const inflatedPrice = (p.price * 1.2).toFixed(0);

              return (
                <div
                  className="product-card-home"
                  key={p.id}
                  onClick={() => setSelectedProduct(p)}
                >
                  <img src={p.imageUrl || "/no-image.png"} alt={p.name} />
                  <h3>{p.name}</h3>

                  <p className="price">
                    <span className="old-price">₹{inflatedPrice}</span>
                    <span className="new-price">₹{p.price}</span>
                    <span className="discount">20% OFF</span>
                  </p>

                  <p className="category">{p.category}</p>
                </div>
              );
            })
          )}
        </div>
      </section> */}

      {/* PRODUCT POPUP MODAL */}
      {/* {selectedProduct && (
        <div className="product-modal-overlay" onClick={() => setSelectedProduct(null)}>
          <div className="product-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setSelectedProduct(null)}>✖</button>

            <img src={selectedProduct.imageUrl} alt={selectedProduct.name} className="modal-img" />

            <h2>{selectedProduct.name}</h2>
            <p><strong>Category:</strong> {selectedProduct.category}</p>
            <p><strong>Price:</strong> ₹{selectedProduct.price}</p>
            <p><strong>Stock:</strong> {selectedProduct.stock}</p>
            <p><strong>Description:</strong> {selectedProduct.description}</p>

          </div>
        </div>
      )} */}
    </>
  );
}
